import { __decorate, __extends } from "tslib";
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);
var PRGLink = /** @class */ (function (_super) {
    __extends(PRGLink, _super);
    function PRGLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menuWidth = null;
        _this.menuHeight = null;
        _this.menuTemplateId = 'c-prglink-contextmenu';
        _this.menuItem1TemplateId = 'c-prglink-contextmenu--item1';
        _this.menuItem2TemplateId = 'c-prglink-contextmenu--item2';
        _this.menuActiveClass = "vue-simple-context-menu--active";
        _this.timer = null;
        _this.touchMove = false;
        _this.lastTouchTime = 0;
        return _this;
    }
    PRGLink.prototype.menuItem1EventHandler = function (e) {
        var _a, _b;
        e.stopPropagation();
        var target = e.target;
        var product = (_b = (_a = target.closest('[data-product]')) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.product;
        var url = document.getElementById(this.menuTemplateId).dataset.url;
        if (url.indexOf('http') !== -1) {
            if (product) {
                this.eecProductClick(product);
            }
            window.open(url, '_blank').focus();
        }
        else {
            if (product) {
                this.eecProductClick(product);
            }
            window.open(location.origin + url, '_blank').focus();
        }
        this.hideContextMenu();
    };
    PRGLink.prototype.menuItem2EventHandler = function (e) {
        var _this = this;
        e.preventDefault();
        e.stopPropagation();
        var url = document.getElementById(this.menuTemplateId).dataset.url;
        if (url.indexOf('http') === -1) {
            url = location.origin + url;
        }
        navigator.clipboard.writeText(url).then(function () {
        }, function () {
        });
        setTimeout(function () {
            _this.hideContextMenu();
        }, 1000);
    };
    PRGLink.prototype.setURL = function (event) {
        var _a, _b;
        var now = Date.now();
        if (event.type === 'click' && now - this.lastTouchTime < 500) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        var target = event.target;
        var product = (_b = (_a = target.closest('[data-productid]')) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.product;
        if (event.ctrlKey) {
            if (product) {
                this.eecProductClick(product);
            }
            window.open(this.url, '_blank').focus();
        }
        else if (event.shiftKey) {
            if (product) {
                this.eecProductClick(product);
            }
            window.open(this.url);
        }
        else if (this.linkTargetBlank) {
            if (product) {
                this.eecProductClick(product);
            }
            window.open(this.url, '_blank').focus();
        }
        else {
            if (product) {
                this.eecProductClick(product);
            }
            window.location.href = this.url;
        }
    };
    PRGLink.prototype.middleClickHandler = function (event) {
        var _a, _b;
        event.preventDefault();
        event.stopPropagation();
        var target = event.target;
        var product = (_b = (_a = target.closest('[data-productid]')) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.product;
        if (product) {
            this.eecProductClick(product);
        }
        window.open(this.url, '_blank').focus();
    };
    PRGLink.prototype.contextMenuHandler = function (event) {
        this.showMenu(event);
    };
    PRGLink.prototype.showMenu = function (event) {
        var _a, _b;
        var target = event.target;
        var product = (_b = (_a = target.closest('[data-product]')) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.product;
        var self = this;
        var path = window.location.pathname;
        var pathSegmentArray = path.split('/');
        var locale = pathSegmentArray[1].toLowerCase();
        if (!document.getElementById(this.menuTemplateId)) {
            var menuItem1Text = 'Im neuen Tab öffnen';
            var menuItem2Text = 'Link Adresse kopieren';
            if (locale === 'fr') {
                menuItem1Text = 'Ouvrir dans un nouvel onglet';
                menuItem2Text = 'Copier le lien';
            }
            document.body.insertAdjacentHTML('beforeend', '<div><ul id="' + this.menuTemplateId + '" class="vue-simple-context-menu"><li class="vue-simple-context-menu__item" id="' + this.menuItem1TemplateId + '"><span>' + menuItem1Text + '</span></li><li class="vue-simple-context-menu__item" id="' + this.menuItem2TemplateId + '"><span>' + menuItem2Text + '</span></li></ul></div>');
            document.getElementById(self.menuItem1TemplateId).addEventListener('click', this.menuItem1EventHandler);
            document.getElementById(self.menuItem1TemplateId).addEventListener('touchend', this.menuItem1EventHandler);
            document.getElementById(self.menuItem2TemplateId).addEventListener('click', this.menuItem2EventHandler);
            document.getElementById(self.menuItem2TemplateId).addEventListener('touchend', this.menuItem2EventHandler);
            if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
                document.getElementById(self.menuItem2TemplateId).style.display = 'none';
            }
        }
        var eventX = (event.type == "touchstart")
            ? event.touches[0].pageX
            : event.pageX;
        var eventY = (event.type == "touchstart")
            ? event.touches[0].pageY
            : event.pageY;
        var menu = document.getElementById(this.menuTemplateId);
        if (!menu) {
            return;
        }
        if (!this.menuWidth || !this.menuHeight) {
            menu.style.visibility = "hidden";
            menu.style.display = "block";
            this.menuWidth = menu.offsetWidth;
            this.menuHeight = menu.offsetHeight;
            menu.removeAttribute("style");
        }
        if (this.menuWidth + eventX >= window.innerWidth) {
            menu.style.left = eventX - this.menuWidth + 2 + "px";
        }
        else {
            menu.style.left = eventX - 2 + "px";
        }
        if (this.menuHeight + eventY >= window.innerHeight) {
            menu.style.top = eventY - this.menuHeight + 2 + "px";
        }
        else {
            menu.style.top = eventY - 2 + "px";
        }
        menu.setAttribute('data-url', this.url);
        menu.setAttribute('data-product', product ? product : '');
        menu.classList.add(this.menuActiveClass);
    };
    PRGLink.prototype.isActiveContextMenu = function () {
        var element = document.getElementById(this.menuTemplateId);
        if (element) {
            return element.classList.contains(this.menuActiveClass);
        }
        return false;
    };
    PRGLink.prototype.hideContextMenu = function () {
        var element = document.getElementById(this.menuTemplateId);
        if (element) {
            element.classList.remove(this.menuActiveClass);
        }
    };
    PRGLink.prototype.touchStartHandler = function (event) {
        if (this.disableTouchStartEvents) {
            return;
        }
        var self = this;
        this.timer = setTimeout(function () {
            self.showMenu(event);
        }, 1500);
    };
    PRGLink.prototype.touchEndHandler = function (event) {
        if (this.disableTouchStartEvents) {
            return;
        }
        this.lastTouchTime = Date.now();
        clearTimeout(this.timer);
        if (!this.isActiveContextMenu() && !this.touchMove) {
            this.setURL(event);
        }
        this.touchMove = false;
    };
    PRGLink.prototype.touchMoveHandler = function (event) {
        this.touchMove = true;
        clearTimeout(this.timer);
    };
    PRGLink.prototype.eecProductClick = function (product) {
        //@ts-ignore
        dataLayer.push({
            event: "select_item",
            ecommerce: {
                items: [JSON.parse(product)]
            }
        });
    };
    __decorate([
        Prop({ default: '#' })
    ], PRGLink.prototype, "url", void 0);
    __decorate([
        Prop({ default: '' })
    ], PRGLink.prototype, "html", void 0);
    __decorate([
        Prop({ default: '' })
    ], PRGLink.prototype, "classes", void 0);
    __decorate([
        Prop({ default: false })
    ], PRGLink.prototype, "linkTargetBlank", void 0);
    __decorate([
        Prop({ default: false })
    ], PRGLink.prototype, "disableTouchStartEvents", void 0);
    PRGLink = __decorate([
        Component({
            components: {}
        })
    ], PRGLink);
    return PRGLink;
}(Vue));
export default PRGLink;
